import client from "../client/client";

class CompanyLogoService {
	getActiveLogo({ companyId }, cancelToken) {
		return client.get(`/companies/${companyId}/logo`, { config: { cancelToken } });
	}

	uploadLogo({ companyId, file }, cancelToken) {
		return client.upload(`/companies/${companyId}/logo`, file, {
			config: { cancelToken },
		});
	}

	getLogoHistory({ companyId }, cancelToken) {
		return client.get(`/companies/${companyId}/logos`, { config: { cancelToken } });
	}

	deleteActiveLogo({ companyId }, cancelToken) {
		return client.delete(`/companies/${companyId}/logo`, { config: { cancelToken } });
	}

	deleteAllLogos({ companyId }, cancelToken) {
		return client.delete(`/companies/${companyId}/logo/all`, { config: { cancelToken } });
	}

	getLogoImage(url, cancelToken) {
		return client.get(url, {
			config: {
				cancelToken,
				responseType: "blob",
			},
		});
	}
}

export default new CompanyLogoService();
